/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{width:100%;margin-bottom:-.85em}\n/*# sourceMappingURL=add-edit-user.component.css.map*/"];
export { styles as styles };
